import { VoidCallback } from '@deqo/foundation';
import { Host } from '../../../Host';
import { Connector, Scheduler } from '../../Container';
import { ParticipantManager } from '../../canvas/participants/ParticipantManager';
import { ToastHub } from './ToastHub';

export const inToastWhenParticipantJoins: Connector = r => {

    const toast = r.call(ToastHub);
    const participants = r.call(ParticipantManager);
    const scheduler = r.call(Scheduler);

    const pendingLeaves = new Map<string, VoidCallback>();

    // When someone leaves, we wait 10s before sending a toast to prevent spamming on refresh or quick leave/joins.  If they rejoin within
    // this window we cancel the leave toast.
    const m = Host.env === 'local' ? 1 : 10;

    return [
        participants.on('leave', p => {
            if (pendingLeaves.has(p.id)) return;
            pendingLeaves.set(p.id, scheduler.invokeAfter(m * 1000, () => {
                pendingLeaves.delete(p.id);
                toast.invoke('ptpt:leave', toast.createSenderContextData(p));
            }));
        }),
        participants.on('join', p => {
            if (pendingLeaves.has(p.id)) {
                const cancel = pendingLeaves.get(p.id);
                cancel();
                pendingLeaves.delete(p.id);
            }
            else {
                toast.invoke('ptpt:join', toast.createSenderContextData(p));
            }
        }),
    ];
};
